import React, { useEffect, useState } from "react";

/**
 * Right-side dot rail showing which of the homepage sections is in view.
 * Sections must have  data-section="unique-id"  and  data-section-label="Nice Name".
 */
export default function SectionProgress() {
  const [sections, setSections] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    const els = Array.from(document.querySelectorAll("[data-section]"));
    setSections(
      els.map((el) => ({
        id: el.dataset.section,
        label: el.dataset.sectionLabel || el.dataset.section,
      }))
    );
    if (els.length === 0) return;

    const obs = new IntersectionObserver(
      (entries) => {
        // Pick the section most in view
        const visible = entries.filter((e) => e.isIntersecting);
        if (visible.length > 0) {
          const top = visible.reduce((a, b) =>
            a.intersectionRatio > b.intersectionRatio ? a : b
          );
          setActive(top.target.dataset.section);
        }
      },
      { threshold: [0.25, 0.5, 0.75] }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  if (sections.length === 0) return null;

  const scrollTo = (id) => {
    const el = document.querySelector(`[data-section="${id}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      aria-label="Section navigation"
      className="hidden lg:flex fixed right-6 top-1/2 -translate-y-1/2 z-40 flex-col items-center gap-3"
    >
      {sections.map((s) => {
        const isActive = s.id === active;
        return (
          <button
            key={s.id}
            onClick={() => scrollTo(s.id)}
            className="group relative flex items-center gap-3"
            aria-label={s.label}
            data-testid={`section-rail-${s.id}`}
          >
            {/* Label popover */}
            <span
              className={`absolute right-6 whitespace-nowrap text-[10px] uppercase tracking-widest font-black transition-all duration-200 ${
                isActive
                  ? "opacity-100 translate-x-0 text-orange-600"
                  : "opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 text-slate-700"
              }`}
              style={{ backgroundColor: "rgba(243,239,231,0.9)", padding: "3px 8px", borderRadius: "9999px", border: "1px solid rgba(249,115,22,0.35)" }}
            >
              {s.label}
            </span>
            {/* Dot */}
            <span
              className={`transition-all duration-300 rounded-full ${
                isActive
                  ? "w-3 h-3 bg-gradient-to-br from-amber-400 to-orange-500 shadow-lg shadow-orange-500/50"
                  : "w-2 h-2 bg-orange-400/40 hover:bg-orange-400/70"
              }`}
            />
          </button>
        );
      })}
    </nav>
  );
}
